import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import axios from "axios";

import store from "./store";

import App from "./components/App";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";

switch (process.env.REACT_APP_BUILD_MODE) {
  case "development":
    axios.defaults.baseURL = "http://qa-api.go-evio.com";
    break;
  case "qa":
    axios.defaults.baseURL = "https://qa-api.go-evio.com";
    break;
  case "pre-production":
    axios.defaults.baseURL = "https://pre-api.go-evio.com";
    break;
  case "production":
    axios.defaults.baseURL = "https://api.go-evio.com";
    break;
  default:
    axios.defaults.baseURL = "https://pre-api.go-evio.com";
}
axios.defaults.headers.common["apikey"] = process.env.REACT_APP_EVIOAPI;

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
